import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SystemErrorPage } from './pages/system-error/system-error.page';
import { NotFoundPage } from './pages/not-found/not-found.page';

const routes: Routes = [
  { path: 'system-error', component: SystemErrorPage },
  { path: 'not-found', component: NotFoundPage }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
